import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStandingMan = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 39,
	height: 39,
	viewBox: "0 0 39 39",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Groupe_452",
		"data-name": "Groupe 452",
		transform: "translate(-336.584 -441.439)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_370",
			"data-name": "Rectangle 370",
			width: 38,
			height: 38,
			transform: "translate(337.084 441.939)",
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsx("path", {
			id: "Trac\\xE9_2191",
			"data-name": "Trac\\xE9 2191",
			d: "M369.524,451.647h-6.307a4.089,4.089,0,1,0-6.017,0h-6.125a3.046,3.046,0,1,0,0,6.091h4.671v16.61a3.049,3.049,0,0,0,3.046,3.046,3.016,3.016,0,0,0,1.888-.674,3.017,3.017,0,0,0,1.885.672,3.049,3.049,0,0,0,3.046-3.049l-.044-16.6h3.957a3.046,3.046,0,1,0,0-6.091Zm-9.315-4.521a1.76,1.76,0,1,1-1.76,1.76A1.762,1.762,0,0,1,360.209,447.126Zm9.315,8.283h-5.108l-.017,0h0a1.161,1.161,0,0,0-1.155,1.107c0,.02-.006.039-.006.059h0l.048,17.771a.717.717,0,0,1-1.434,0V463.569a1.164,1.164,0,0,0-1.164-1.164,1.147,1.147,0,0,0-.238.025,1.164,1.164,0,0,0-.936,1.141v10.778a.717.717,0,0,1-1.435,0V456.574a1.165,1.165,0,0,0-1.164-1.164h-5.835a.717.717,0,1,1,0-1.433h18.448a.717.717,0,1,1,0,1.433Z",
			transform: "translate(-4.573 -1.194)",
			fill: "#cce4f4"
		})]
	})]
});
const ForwardRef = forwardRef(SvgStandingMan);
export { ForwardRef as ReactComponent };
